import React from 'react';
import './BottomNavigation.css';
import mainIcon from '../assets/icons/main.svg';
import chatsIcon from '../assets/icons/chats.svg';
import favorIcon from '../assets/icons/favor.svg';
import infoIcon from '../assets/icons/info.svg';

const BottomNavigation = ({ 
  currentTab, 
  onHomeClick, 
  onTabChange,
  onAboutClick
}) => {
  return (
    <>
      {/* Градиентный блок для плавного перехода */}
      <div className="bottom-gradient-overlay"></div>
      
      <nav className="bottom-nav">
        <button 
          className={`nav-item ${currentTab === 'home' ? 'active' : ''}`}
          onClick={onHomeClick}
        >
          <img 
            src={mainIcon} 
            alt="Главная" 
            className={`nav-icon ${currentTab === 'home' ? 'active' : ''}`}
          />
          <span className="nav-label">Главное</span>
        </button>
        
        <button 
          className={`nav-item ${currentTab === 'chats' ? 'active' : ''}`}
          onClick={() => onTabChange('chats')}
        >
          <img 
            src={chatsIcon} 
            alt="Чаты" 
            className={`nav-icon ${currentTab === 'chats' ? 'active' : ''}`}
          />
          <span className="nav-label">Чаты</span>
        </button>
        
        <button 
          className={`nav-item ${currentTab === 'favorites' ? 'active' : ''}`}
          onClick={() => onTabChange('favorites')}
        >
          <img 
            src={favorIcon} 
            alt="Избранное" 
            className={`nav-icon ${currentTab === 'favorites' ? 'active' : ''}`}
          />
          <span className="nav-label">Избранное</span>
        </button>
        
        <button 
          className={`nav-item ${currentTab === 'about' ? 'active' : ''}`}
          onClick={onAboutClick}
        >
          <img 
            src={infoIcon} 
            alt="О нас" 
            className={`nav-icon ${currentTab === 'about' ? 'active' : ''}`}
          />
          <span className="nav-label">О нас</span>
        </button>
      </nav>
    </>
  );
};

export default BottomNavigation; 